module.exports = "https://static.wmbcdn.com/uniweb/images/0f750fad020fba0ae0e9466bb9842740.svg";